export type SwitchableTeam = {
  id: string
  name: string
}

/**
 * docs/product/personas.md's "A supervisor owns one or more teams."
 * Renders nothing when there is only the one, the same way the planning
 * board never built a team filter when this pilot's roster had nothing to
 * distinguish: a switcher with one team to switch to is not a control at
 * all, just a static fact better said in a page's own subtitle instead.
 */
export default function TeamSwitcher({
  teams,
  currentTeamId,
  onChange,
}: {
  teams: SwitchableTeam[]
  currentTeamId: string
  onChange: (teamId: string) => void
}) {
  if (teams.length <= 1) return null

  return (
    <div role="group" aria-label="Which team" className="flex gap-0.5 self-start rounded-control bg-surface-2 p-0.5">
      {teams.map((team) => (
        <button
          key={team.id}
          type="button"
          aria-pressed={currentTeamId === team.id}
          onClick={() => onChange(team.id)}
          className={`flex min-h-11 items-center justify-center rounded-[5px] px-4 text-small font-bold ${
            currentTeamId === team.id ? 'bg-canvas text-ink shadow-sm' : 'text-ink-subtle'
          }`}
        >
          {team.name}
        </button>
      ))}
    </div>
  )
}
